import { Box, Divider, Typography } from "@mui/material";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomTooltipBorder from "../../../../components/CustomTooltipBorder";
import DetectionLabelIcon from "./DetectionLabelIcon";

const DetectionsTooltip = ({ content, children }) => {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const handleTooltipOpen = () => {
    trackEvent("DetectionsTooltip");
  };
  return (
    <CustomTooltipBorder
      title={
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
            }}
          >
            <DetectionLabelIcon />

            <Typography variant="overline">Detections</Typography>
          </Box>

          <Divider />
          <Box>{content}</Box>
        </Box>
      }
      borderColor={colors.error_dark}
      onOpen={handleTooltipOpen}
      arrow
    >
      {children}
    </CustomTooltipBorder>
  );
};

export default DetectionsTooltip;
